import { useExperiments as useLizardExperiments } from '@wix/funnel-builder-lizard'
import { tryCatchSync } from '@wix/funnel-utils'
import { useMemo } from 'react'

import { type Experiments, toExperiments } from '../utils/experiments'

type ExperimentValues = Record<string, string>

const parseRenderedExperiments = () => {
  const [, experiments = {}] = tryCatchSync(() => JSON.parse(window.__EXPERIMENTS__ || '{}') as ExperimentValues)
  return experiments
}

export const useExperiments = (): Experiments => {
  const lizardExperiments = useLizardExperiments()
  const renderedExperiments = useMemo(parseRenderedExperiments, [window.__EXPERIMENTS__])

  return useMemo(
    () =>
      toExperiments({
        ...renderedExperiments,
        ...lizardExperiments,
      }),
    [lizardExperiments, renderedExperiments],
  )
}
